import React from 'react';
import dayjs from 'dayjs';
import { InputNumber, DatePicker, Select } from 'antd';
import type { InternalMedicineData } from '../../hooks/useConsultationForm';

interface Props {
  internalMedicineData: InternalMedicineData;
  setInternalMedicineField: (section: keyof InternalMedicineData, field: string, value: any) => void;
}

const TREATMENT_OPTIONS = [
  { value: 'Dieta', label: 'Dieta' },
  { value: 'Estatina', label: 'Estatina' },
  { value: 'Fibrato', label: 'Fibrato' },
  { value: 'Otro', label: 'Otro' },
];

const DyslipidemiaSection: React.FC<Props> = ({ internalMedicineData, setInternalMedicineField }) => {
  const dys = internalMedicineData.dyslipidemia;
  const set = (field: string, value: any) => setInternalMedicineField('dyslipidemia', field, value);

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">Dislipidemia</h5>
        <div className="row mt-3">
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">LDL (mg/dL)</label>
              <InputNumber
                className="w-100"
                min={0}
                step={0.1}
                value={dys.ldl}
                onChange={(v) => set('ldl', v)}
                placeholder="mg/dL"
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">HDL (mg/dL)</label>
              <InputNumber
                className="w-100"
                min={0}
                step={0.1}
                value={dys.hdl}
                onChange={(v) => set('hdl', v)}
                placeholder="mg/dL"
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Triglicéridos (mg/dL)</label>
              <InputNumber
                className="w-100"
                min={0}
                value={dys.triglycerides}
                onChange={(v) => set('triglycerides', v)}
                placeholder="mg/dL"
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Colesterol Total (mg/dL)</label>
              <InputNumber
                className="w-100"
                min={0}
                step={0.1}
                value={dys.total_cholesterol}
                onChange={(v) => set('total_cholesterol', v)}
                placeholder="mg/dL"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Fecha Perfil Lipídico</label>
              <DatePicker
                className="w-100"
                value={dys.lipid_profile_date ? dayjs(dys.lipid_profile_date) : null}
                onChange={(date) => set('lipid_profile_date', date ? date.format('YYYY-MM-DD') : null)}
                format="YYYY-MM-DD"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Tratamiento</label>
              <Select
                className="w-100"
                value={dys.treatment || undefined}
                onChange={(v) => set('treatment', v)}
                placeholder="Seleccionar..."
                options={TREATMENT_OPTIONS}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Observaciones</label>
              <textarea
                className="form-control"
                rows={2}
                value={dys.observations}
                onChange={(e) => set('observations', e.target.value)}
                placeholder="Notas adicionales sobre dislipidemia..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DyslipidemiaSection;
